"use client";
import { useEffect } from "react";

export function useFixedBottomSpacer(heightInPx: number) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.style.setProperty(
        "--fixed-bottom-height",
        `${heightInPx}px`
      );

      return () => {
        document.documentElement.style.setProperty(
          "--fixed-bottom-height",
          "0px"
        );
      };
    }
  }, [heightInPx]);
}
